export interface Discount {
  id: number;
  id_company: number;
  name: string;
  public_name: string | null;
  rule_type: 'bundle' | 'volume' | 'promo_code' | 'pass';
  discount_mode: 'percentage' | 'fixed';
  discount_value: number;
  max_discount_amount: number | null;
  allowed_channels: number[] | null;
  active: boolean;
  starts_at: string | null;
  ends_at: string | null;
  priority: number;
  min_quantity: number | null;
  min_cart_amount: number | null;
  buy_quantity: number | null;
  pay_quantity: number | null;
  apply_scope: 'company' | 'event' | 'session';
  application_target: 'all_affected' | 'each_ticket' | 'condition_block' | null;
  session_strict_mode?: boolean;
  metadata: Record<string, any> | null;
  created_at: string;
  updated_at: string;
  events?: any[];
  sessions?: any[];
  promo_codes?: PromoCode[];
}

export interface PromoCode {
  id: number;
  discount_id: number;
  code: string;
  max_uses: number | null;
  uses_per_customer: number;
  active: boolean;
  created_at: string;
  updated_at: string;
  discount?: Discount;
  usages?: PromoCodeUsage[];
}

export interface PromoCodeUsage {
  id: number;
  promo_code_id: number;
  id_user: number | null;
  id_order: number | null;
  created_at: string;
  updated_at: string;
}

export interface DiscountChannel {
  id: number;
  name: string;
}

export interface DiscountOptions {
  rule_types: string[];
  discount_modes: string[];
  application_targets: string[];
  scope_types: string[];
  channels?: DiscountChannel[];
}

export const PROMO_CODE_ERRORS: Record<string, string> = {
  'Invalid or inactive promo code': 'Código promocional inválido o inactivo',
  'Promo code discount is not active or expired': 'Este código promocional ha expirado o no está activo',
  'Promo code has reached its maximum uses': 'Este código ha alcanzado el límite máximo de usos',
  'You have reached the limit of uses for this promo code': 'Ya has utilizado este código el número máximo de veces permitido',
  'Promo code is not valid for this sales channel': 'Este código promocional no es válido para este canal de venta',
  'Unauthorized': 'No tienes permisos para realizar esta acción',
};

export const RULE_TYPE_LABELS: Record<string, string> = {
  'bundle': 'Por paquete',
  'volume': 'Por volumen',
  'promo_code': 'Código promo',
};

export const DISCOUNT_MODE_LABELS: Record<string, string> = {
  'percentage': 'Porcentaje',
  'fixed': 'Importe fijo',
};

export const SCOPE_LABELS: Record<string, string> = {
  'company': 'Empresa',
  'event': 'Evento',
  'session': 'Sesión',
};
